const Supplement = Object.freeze({
  ASHWAGANDHA: "Ashwagandha",
  BERBERINE: "Berberine",
  CALCIFEDIOL: "Calcifediol",
  CALCIUM: "Calcium",
  CREATINE: "Creatine",
  CHONDROITIN: "Chondroitin",
  IRON: "Iron",
  MAGNESIUM: "Magnesium",
  MELATONIN: "Melatonin",
  MILK_THISTLE: "Milk Thistle",
  OMEGA_3S: "Omega-3s",
  POTASSIUM: "Potassium",
  PROTEIN: "Protein",
  RED_YEAST_RICE: "Red Yeast Rice",
  SELENIUM: "Selenium",
  SOLUBLE_FIBER: "Soluble Fiber",
  VITAMIN_B2: "Vitamin B2",
  VITAMIN_B6: "Vitamin B6",
  BIOTIN: "Vitamin B7 (Biotin)", //"Biotin (Vitamin B7)",
  VITAMIN_B9: "Vitamin B9 (Folate)", // "Vitamin B9", 
  VITAMIN_B12: "Vitamin B12",
  VITAMIN_C: "Vitamin C",
  VITAMIN_D_OR_CALCIFEDIOL: "Vitamin D or Calcifediol",
  VITAMIN_D3: "Vitamin D3",
  VISCOUS_FIBER: "Viscous Fiber",
  ZINC: "Zinc",
  TMG: "TMG",
});

export default Supplement;
